// extracted by mini-css-extract-plugin
export default {"container":"autocompleteChip_container__9+FXO","chips":"autocompleteChip_chips__AvtGp","chipsContainer":"autocompleteChip_chipsContainer__4b02t"};